import { Component, OnInit, OnChanges } from "@angular/core";
import { HistoricVar, QueryReadings } from "../../../devices/device.model";
import { DevicesService } from "../../../devices/devices.service";
import { DatePipe } from "@angular/common";
import { Constants } from "../../../../shared/constants";
import { SharedUtils } from "../../../../shared/shared.utils";
import { GeneralService } from "../../../../shared/services/general.service";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { Device } from "../../../devices/devices.model_new";
import { GROUP } from "../../../devices/devices.constant";

@Component({
  selector: "app-generation-resume",
  templateUrl: "./generation-resume.component.html",
  styleUrls: ["./generation-resume.component.scss"],
})
export class GenerationResumeComponent implements OnInit {
  SharedUtils = SharedUtils;

  sourceIds: Map<string, HistoricVar>;
  mode = "kWh";
  activeView = "day";
  selectionSeconds = "86400";
  integrationPeriodType = "0";
  selectedDate: string;
  customEnd: Date;
  currentSelectedDate = new Date(Date.now());
  public selectedMoments;

  totalGeneration: number;
  injectionMeter: Device;

  constructor(
    private devicesService: DevicesService,
    private datePipe: DatePipe,
    private generalService: GeneralService,
    private sessionStateService: SessionStateService
  ) {}
  ngOnInit() {
    this.devicesService
      .getInjectionMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((meter) => {
        this.injectionMeter = this.findInjectionMeter(meter);
      });
  }

  changeMode(event) {
    this.mode = event;
  }

  findInjectionMeter(meters: Device[]) {
    let injectionMeter: Device = meters[0];
    meters.forEach((meter) => {
      if (!meter.getGroups().has(GROUP.CONSUMPTION_METER)) {
        injectionMeter = meter;
      }
    });
    return injectionMeter;
  }
  totalsUpdate(event) {
    if (event[0] === "reset") {
      this.totalGeneration = 0;
    } else if (event[0] === "production") {
      if (this.mode === "Eur") {
        this.totalGeneration =
          event[1] && event[1].cost.D ? event[1].cost.D : 0;
      } else {
        this.totalGeneration =
          event[1] && event[1].value.D ? event[1].value.D : 0;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-resume/generation-resume/generation-resume.component.ts